module.exports = __webpack_public_path__ + "static/media/violet.47447aba.png";